module.exports = __webpack_public_path__ + "img/kidney.6e286c37.png";